import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDocumentoTraslacion,
  getTiposDocumentosTraslacion,
  patchTipoDocumentoTraslacion,
  postTipoDocumentoTraslacion,
} from 'api/catalogos/tiposDocumentosTraslacion';

export const permissionConfig = {
  permissionModel: 'tipodedocumentodetraslacion',
};

// eslint-disable-next-line react/prop-types
const TiposDeDocumentosTraslacion = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Documento de Traslación"
    permission={permission}
    get={getTiposDocumentosTraslacion}
    post={postTipoDocumentoTraslacion}
    patch={patchTipoDocumentoTraslacion}
    delete={deleteTipoDocumentoTraslacion}
    withoutState
    fields={[defaultFields.descripcion]}
  />
);

export default TiposDeDocumentosTraslacion;
